// extracted by mini-css-extract-plugin
export default {"placeholder":"Loader_placeholder__9v2hT","shimmer":"Loader_shimmer__P0F3n"};